import type { StickerIllustrationProps } from '../Sticker';

export const ThumbStickerIllustration = ({ size }: StickerIllustrationProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 90 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.2287 15.3628C32.6855 10.4901 36.3262 6.00405 41.3852 5.95862C47.8272 5.90096 53.45 10.3489 55.1297 16.617L58.0017 27.3356C58.3346 28.578 58.5372 29.3254 58.736 29.8645C58.9216 30.368 59.0093 30.4129 58.964 30.3686C59.0691 30.4716 59.1895 30.542 59.3107 30.583C59.3572 30.5855 59.4912 30.5861 59.7693 30.54C60.3024 30.4517 61.0128 30.2645 62.2202 29.9409L63.6191 29.5661C66.5687 28.7757 68.9835 28.1254 70.935 27.805C72.8989 27.4825 74.8118 27.413 76.6274 28.1349L77.0528 28.3151C79.159 29.2649 80.8886 30.9078 81.9709 32.9653L82.1315 33.2893C82.895 34.9211 83.0484 36.7223 82.9951 38.6255C82.9385 40.6471 82.6261 43.1852 82.2451 46.308L81.8578 49.4771C81.6875 50.8722 81.8458 52.2982 82.3214 53.6335C86.3954 65.0681 79.7976 77.6013 68.0335 80.0409L30.6516 87.7917L30.6506 87.7919C26.9693 88.5551 23.9384 89.2958 20.7626 87.8512L20.4543 87.7043C17.2425 86.1029 16.0955 83.6321 14.592 80.6391C13.1792 77.8264 11.7241 74.3092 10.6155 70.1719C9.38616 65.5836 8.90697 61.4431 8.77678 58.1139C8.52738 51.7313 13.4388 47.1976 19.1056 46.4373C29.368 45.0609 36.5244 35.1947 34.7261 24.4185L33.2938 15.8357L33.2287 15.3628Z"
      fill="#B9B5D0"
      stroke="white"
      strokeWidth="5.625"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.6483 48.5068L26.5966 50.249C26.2619 61.5301 29.4197 72.6393 35.6382 82.0577"
      fill="#B9B5D0"
    />
    <path
      d="M26.6483 48.5068L26.5966 50.249C26.2619 61.5301 29.4197 72.6393 35.6382 82.0577"
      stroke="#746BA1"
      strokeWidth="7.3125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
